import { NotificarePushUI } from './notificare-push-ui';

export * from './notificare-push-ui';

export default NotificarePushUI;
